<template>
    <div class="row modalConVinculo">
        <ul>
            <li v-for="contenidoDeLaPaginaWeb in seccionDeLaPaginaWeb.ContenidosDeLaPaginaWeb" v-bind:key="contenidoDeLaPaginaWeb.ContenidoDeLaPaginaWebId">
                <a data-toggle="modal" v-bind:data-target="'#modal_' + contenidoDeLaPaginaWeb.ContenidoDeLaPaginaWebId">{{contenidoDeLaPaginaWeb.TextoDelVinculo}}</a>
            </li>
        </ul>
        <div v-for="contenidoDeLaPaginaWeb in seccionDeLaPaginaWeb.ContenidosDeLaPaginaWeb" v-bind:key="'modal_' + contenidoDeLaPaginaWeb.ContenidoDeLaPaginaWebId" class="modal justify-content-center fade" v-bind:id="'modal_' + contenidoDeLaPaginaWeb.ContenidoDeLaPaginaWebId" tabindex="-1" aria-labelledby="nombreDelModal" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="nombreDelModal">{{contenidoDeLaPaginaWeb.TextoDelVinculo}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <p class="page-text">{{contenidoDeLaPaginaWeb.TextoDelContenido}}</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal"><i class="fa fa-window-close"></i>&nbsp;&nbsp;Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        seccionDeLaPaginaWeb: Object
    }
}
</script>

<style scoped>
  a {
    color: rgb(33,33,33);
    cursor: pointer;
  }

  .modalConVinculo a {
    width: 100%;
    font-size: 1.2em;
    padding: 8px 0;
  }

  .modalConVinculo li {
    padding-bottom: 10px;
  }

  .modalConVinculo .modal-content {
    background-color: #FFF;
  }

  .modalConVinculo .close {
    color: #000;
  }
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaInformativa/Formatos/VinculoConModal.vue